<template>
  <div class="w-full lg:px-12 md:px-12 px-5 py-10">
    <div class="text-center">
      <h2 class="text-xl text-11111 font-bold">Register</h2>
      <div class="lg:flex md:flex items-center justify-center mb-6 mt-4">
        <span class="text-primary">Already have an account?</span>
        <h4
          class="font-bold text-md ml-4 cursor-pointer lg:mt-0 md:mt-0 mt-2"
          @click="handleOpenPop()"
        >
          Login Now
        </h4>
      </div>
    </div>
    <div class="custh">
      <div class="mt-4">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          autocomplete="nope"
        >
          <div class="mb-2">
            <label class="font-semibold text-black fsize14">Who are you </label>
            <el-form-item prop="role" autocomplete="nope">
              <el-select
                v-model="ruleForm.role"
                placeholder="Want to List your Startup"
                class="w-full"
              >
                <el-option label="Investor" value="investor"></el-option>
                <el-option label="Startup" value="startup"></el-option>
                <el-option label="Accelerator" value="accelerator"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="lg:flex md:flex justify-between">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:pr-2 md:pr-2 pr-0">
              <label class="font-semibold text-black fsize14"
                >First Name
              </label>
              <el-form-item prop="fname">
                <el-input
                  placeholder="Enter or Type"
                  v-model.trim="ruleForm.fname"
                  autocomplete="none"
                  class="mt-0"
                  name="name"
                ></el-input>
              </el-form-item>
            </div>

            <div class="lg:w-1/2 md:w-1/2 w-full lg:pl-2 md:pl-2 pl-0">
              <label class="font-semibold text-black fsize14">Last Name </label>
              <el-form-item prop="lname">
                <el-input
                  placeholder="Enter or Type"
                  v-model.trim="ruleForm.lname"
                  autocomplete="off"
                  class="mt-0"
                  name="name"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mb-4">
            <label class="font-semibold text-black fsize14">Email </label>
            <el-form-item prop="email">
              <el-input
                placeholder="Enter or Type"
                v-model.trim="ruleForm.email"
                autocomplete="false"
                class="mt-0"
                name="email"
              ></el-input>
              <p
                v-if="
                  ruleForm.mobile.length >= 10 &&
                  ruleForm.mobile.length <= 10 &&
                  enableOTP
                "
                class="absolute right-4 top-3 text-sm font-semibold text-primary cursor-pointer"
                @click="handleClick()"
              >
                Get OTP
              </p>
            </el-form-item>
          </div>
          <div class="lg:flex md:flex justify-between">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:pr-2 md:pr-2 pr-0">
              <label class="font-semibold text-black fsize14"
                >Phone Number</label
              >
              <el-form-item prop="mobile">
                <div class="relative">
                  <el-input
                    placeholder="Enter or Type"
                    v-model.trim="ruleForm.mobile"
                    autocomplete="none"
                    class="mt-0"
                    maxlength="10"
                    name="mobile"
                  ></el-input>
                </div>
              </el-form-item>
            </div>

            <div class="lg:w-1/2 md:w-1/2 w-full lg:pl-2 md:pl-2 pl-0">
              <label class="font-semibold text-black fsize14">Enter OTP </label>
              <el-form-item prop="otp" required>
                <el-input
                  placeholder="Enter OTP"
                  v-model.trim="ruleForm.otp"
                  class="mt-0"
                  autocomplete="off"
                  maxlength="4"
                  name="otp"
                  :disabled="
                    !(ruleForm.mobile.length == 10 && ruleForm.condition)
                  "
                ></el-input>
                <p
                  class="absolute right-4 top-3 text-sm font-semibold text-primary cursor-pointer"
                  v-if="countDown != 0 && exCondition"
                >
                  Expire in {{ countDown }}
                </p>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="lg:flex md:flex justify-between">
            <div class="mb-10 lg:w-1/2 md:w-1/2 w-full lg:pr-2 md:pr-2 pr-0">
              <label class="font-semibold text-black fsize14">Password </label>
              <el-form-item prop="password">
                <el-input
                  placeholder="Enter or Type"
                  v-model.trim="ruleForm.password"
                  autocomplete="new-password"
                  class="mt-0"
                  show-password
                  name="password"
                  type="password"
                ></el-input>
              </el-form-item>
            </div>
            <div class="mb-2 lg:w-1/2 md:w-1/2 w-full lg:pl-2 md:pl-2 pl-0">
              <label class="font-semibold text-black fsize14"
                >Confirm Password
              </label>
              <el-form-item prop="confirmpassword">
                <el-input
                  placeholder="Enter or Type"
                  v-model.trim="ruleForm.confirmpassword"
                  autocomplete="new-password"
                  class="mt-0"
                  show-password
                  name="password"
                  type="password"
                ></el-input>
              </el-form-item>
            </div>
          </div> -->
          <!-- <label
            class="font-normal text-828f99 fsize14 text-danger flex items-center"
            v-if="ruleForm.password != ruleForm.confirmpassword"
            >Password Does not Match
          </label> -->
          <p class="text-black text-sm" @click="handleShow">
            Have a Referal Code? Click Here
          </p>
          <div class="relative" v-show="showRef">
            <el-form-item prop="referralCode">
              <el-input
                placeholder="Enter or Type"
                v-model.trim="ruleForm.referralCode"
                class="mt-0"
                maxlength="8"
                name="referralCode"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="text-center">
        <b-button
          variant="primary"
          class="rounded-lg mt-4 py-3 w-full"
          @click="register('ruleForm')"
          >Register</b-button
        >
      </div>

      <el-divider content-position="center">or</el-divider>
      <div class="flex justify-center mt-4">
        <div
          class="btn-fb flex items-center m-2 rounded-md"
          @click="getAuthUrl"
        >
          <div
            class="bg-white ml-2 w-6 h-6 items-center justify-center rounded-full flex"
          >
            <!-- <img
              src="@/assets/images/gg2.png"
              class="h-4 w-4 my-auto"
              alt="Google"
            /> -->
          </div>
          <p
            class="text18 font-semibold uppercase lg:px-4 md:px-4 px-2 py-2 text-white"
          >
            SIGN UP with GOOGLE
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showRef: false,
      number: "",
      otp: "",
      exCondition: false,
      enableOTP: true,
      name: "",
      email: "",
      // password: "",
      // cpassword: "",
      role: "",
      countDown: 30,
      ruleForm: {
        fname: "",
        lname: "",
        email: "",
        mobile: "",
        otp: "",
        // password: "",
        // confirmpassword: "",
        condition: false,
        role: "investor",
        referralCode: "",
      },
      rules: {
        fname: [
          {
            required: true,
            message: "Please Enter First Name",
            trigger: "blur",
          },
        ],
        lname: [
          {
            required: true,
            message: "Please Enter Last Name",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Please Enter email address",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email address",
            trigger: ["blur", "change"],
          },
        ],
        mobile: [
          {
            required: true,
            message: "Please Enter Mobile Number",
            trigger: "blur",
          },

          {
            min: 10,
            max: 10,
            message: "Mobile Number should be 10 Digits",
            trigger: "blur",
          },
          {
            pattern: /^\d*$/,
            message: "Mobile must be a number",
            trigger: "blur",
          },
          {
            pattern: /^[789]/,
            message: "Please Enter Valid Mobile Number",
            trigger: "blur",
          },
        ],
        otp: [
          {
            required: true,
            message: "Please Enter OTP Number",
            trigger: "blur",
          },
          {
            min: 4,
            max: 4,
            message: "OTP Number should be 4 Digits.",
            trigger: "blur",
          },
          {
            pattern: /^\d*$/,
            message: "OTP must be a number",
            trigger: "blur",
          },
        ],
        // password: [
        //   {
        //     required: true,
        //     message: "Please Enter Password",
        //     trigger: "blur",
        //   },
        //   {
        //     pattern:
        //       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
        //     message:
        //       "Password must contain atleast 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
        //     trigger: "blur",
        //   },
        // ],
        // confirmpassword: [
        //   {
        //     required: true,
        //     message: "Please Repeat Above Password",
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },

  methods: {
    async handleClick() {
      const payload = {
        mobile: this.ruleForm.mobile,
        email: this.ruleForm.email,
        type: "Register",
      };

      try {
        const data = await this.$store.dispatch("auth/generateOTP", payload);
        this.$notify({
          message:
            "OTP has been sent on you email address and mobile number, please check!",
          type: "success",
          position: "bottom-right",
        });
        this.exCondition = true;
        this.countDown = 30;
        (this.enableOTP = false), (this.ruleForm.condition = true);
        this.countDownTimer();
        return condition;
      } catch (error) {
        console.log(error);
        this.error(error);
      }
    },
    async register(formName) {
      if (this.showRef && this.ruleForm && !this.ruleForm.referralCode) {
        this.showRef = false;
        if (this.rules["referralCode"]) delete this.rules.referralCode;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.ruleForm.password != this.ruleForm.confirmpassword) {
          //   this.passworderror();
          // } else {
          this.NewRegister();
          // }
        } else {
          this.formfeild();
          return false;
        }
      });
    },
    async NewRegister() {
      const payload = {
        firstname: this.ruleForm.fname,
        lastname: this.ruleForm.lname,
        mobile: this.ruleForm.mobile,
        email: this.ruleForm.email.toLowerCase(),
        password: "Admin@123",
        otp: this.ruleForm.otp,
      };
      if (this.ruleForm.role) {
        Object.assign(payload, { role: this.ruleForm.role });
        Object.assign(payload, { startupStatus: "false" });
      }
      if (this.ruleForm.referralCode) {
        Object.assign(payload, { referralCode: this.ruleForm.referralCode });
      }
      try {
        const data = await this.$store.dispatch(
          "auth/signupWithPassword",
          payload
        );

        if (data.code == 200) {
          this.$store.commit("UI/OPEN_REG_POP", false);
          this.$notify({
            message: "You have registered successfully!",
            type: "success",
            position: "bottom-right",
          });
          this.resetForm("ruleForm");
          // console.log(data);
          if (data.data.user.role == "startup") {
            this.$router.push({ name: "Raisedfund" });
          }
        }
      } catch (error) {
        console.log(error);
        this.error(error);
      }
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
      if (this.countDown == 0) {
        this.enableOTP = true;
      }
    },

    async getAuthUrl() {
      try {
        this.$store.commit("auth/loginAction", "login");
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$homeAuth,
          scopes: ["profile", "email"],
        });
        window.open(res.data, "_self");
      } catch (error) {
        this.error(error);
      }
    },

    handleOpenPop() {
      this.$store.commit("UI/OPEN_LOGIN_POP", true);
    },
    error(error) {
      this.$notify.error({
        message: error.response.data.message,

        position: "bottom-right",
      });
    },

    passworderror() {
      this.$notify.error({
        message: "Both Password dose not match",

        position: "bottom-right",
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formfeild() {
      this.$notify.error({
        message: "Please fill all the required details",

        position: "bottom-right",
      });
    },
    success() {
      this.$notify({
        message: "You have register successfully!",
        type: "success",
        position: "bottom-right",
      });
    },
    handleShow() {
      this.showRef = true;
      Object.assign(this.rules, {
        referralCode: [
          {
            required: true,
            message: "Please Enter Referral Code",
            trigger: "blur",
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
/* .custh {
  overflow-y: auto;
  height: 500px;
} */
</style>
